import { Helmet } from "react-helmet"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useModuleSettings } from "../../components/moduleSettingsContext/ModuleSettingsContext";
import { notifications } from "../../slices/notificationSlice";
import { useEffect, useState } from "react";
import moment from "moment";
import { getUserPermissions, isAdmin } from "../../common/LocalStorageService";
import Spinner from "../../components/spinner";
import DataTable from "react-data-table-component";
import { language } from "../../slices/languageSlice";
import ViewModal from "./modal";

export const Notification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { notificationList, addNotificationData, loading, error, success } = useSelector((state) => state.notification);
    const { filter, setFilter, search, setSearch, page, setPage, limit, setLimit, lang, setLang, resetSettings } = useModuleSettings();
    const { languageList } = useSelector((state) => state.language);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState({});
    const [field, setField] = useState({});

    useEffect(() => {
        if (filter == 'all') {
            return setFilter('')
        }
        if (lang == 'ENGLISH') {
            return setLang('')
        }
        dispatch(notifications({ filter, search, page, limit, language_id: parseInt(lang) }));
    }, [dispatch, filter, search, page, limit, lang]);

    useEffect(() => {
        dispatch(language({ limit: 1000 }));
    }, [dispatch]);

    const handleView = (row) => {
        setField({
            title: "Notification Details",
            _title: "Title",
            message: "Message",
            language: "Language",
            date: "Date"
        })
        setData(row);
        setIsModalOpen(true)
    };

    const handleCloseModal = () => {
        setField({})
        setData({})
        setIsModalOpen(false);
    };

    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            maxWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Title",
            selector: (row, index) => row?.title,
            minWidth: "250px",
            maxWidth: "500px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Message",
            selector: (row, index) => row.message,
            minWidth: "300px",
            maxWidth: "500px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Language",
            selector: (row) => row?.notification_language?.name || '-',
            sortable: true,
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Created Date",
            selector: (row) => moment(row.createdAt).format("DD-MMM-YYYY"),
            sortable: true,
            minWidth: "80px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className="btn" onClick={() => handleView(row)}>
                        <i
                            className="fe-eye font-22 avatar-title text-primary"
                            style={{ color: "blue" }}
                        />
                    </button>
                </div>
            ),
            minWidth: "100px",
            style: {
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
            },
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
            },
        },
    };

    const handleFilterChange = (event) => {
        const newFilter = event.target.value;
        setFilter(newFilter);
    };

    const handleSearchChange = (event) => {
        const newSearch = event.target.value;
        setSearch(newSearch);
    };

    const handleLanguageChange = (event) => {
        const newLanguage = event.target.value;
        resetSettings();
        setLang(newLanguage);
    };

    const handleAdd = () => {
        navigate("/notification/add");
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (newLimit) => {
        setLimit(newLimit);
    };

    if (loading) {
        return (
            <Spinner />
        )
    }

    return (
        <>
            <Helmet>
                <title>LEA.TRAINING | Notifications</title>
            </Helmet>

            <div className="content-page">
                {/* <button className="btn btn-sm" onClick={() => navigate(-1)}>
                    <i className="fe-arrow-left font-22 avatar-title text-secondary" />
                </button> */}
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className={`widget-rounded-circle card`}>
                        <div className="card-body">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <div>
                                    <h3 className="text-info">Notifications</h3>
                                </div>
                            </div>
                            <div className="row">
                                <DataTable
                                    title={null}
                                    columns={columns}
                                    data={notificationList.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={notificationList?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                                    onChangeRowsPerPage={handleRowsPerPageChange}
                                    onChangePage={handlePageChange}
                                    responsive
                                    selectableRowsHighlight
                                    highlightOnHover
                                    striped
                                    subHeader
                                    fixedHeader
                                    fixedFooter
                                    persistTableHead
                                    subHeaderWrap
                                    subHeaderAlign="left"
                                    noDataComponent={<h5 className="p-3">No Data Found</h5>}
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                {(isAdmin() || getUserPermissions("course").is_add) &&
                                                    <button className="btn btn-primary" onClick={handleAdd} style={{ padding: "4px 20px" }}>Add</button>}
                                            </div>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <div>
                                                    <select value={lang} onChange={handleLanguageChange} style={{ padding: "5px 20px" }}>
                                                        <option value=''>
                                                            ALL
                                                        </option>
                                                        {languageList?.data?.map((langItem) => (
                                                            <option key={langItem.id} value={langItem.id}>
                                                                {langItem.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ViewModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                data={data}
                field={field}
            />
        </>
    )
}